import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { MODE_LONG_TITLES } from '../../lib/modesHelper';
import Header from '../Main/Header';
import ErrorBoundary from '../ErrorBoundary';
import AbcPlayer from '../AbcPlayer';
import BookProvider from '../../lib/bookProvider';
import TextPlayer from './TextPlayer';
import Player from '../Player';

class Karaoke extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      score: null,
      // player:
      playing: false,
      currentTime: 0,
      duration: 100,
      bpm: 180
    };
  }

  render() {
    const header_classes = { Header: 'Mode-karaoke' };
    const { playing, duration, currentTime, bpm, score } = this.state;
    const score_id = this.props.match.params.score_id;
    const title = score ? score.title : '';
    const author = score ? score.author : '';
    return [
      <Header key={1} classes={header_classes} karaokeMode={true} title={MODE_LONG_TITLES['karaoke']} />,
      <div key={2} className={'Body Mode-karaoke'}>
        <div className="Main-Column">
          <div className="Main-Column-Header">
            {title && <h2 className="Main-Tune-Title">{title}</h2>}
            {author && <h3 className="Main-Tune-Author">{author}</h3>}
          </div>
          <div className="Main-Column-Inner">
            <div className="Main-Score Karaoke-Main-Score">
              <TextPlayer score_id={score_id} playing={playing} currentTime={currentTime} />
              <Player
                playing={playing}
                currentTime={currentTime}
                score={score}
                karaoke={true}
                onTuneLoaded={this.tuneLoaded}
                onAudioTimeUpdate={this.audioTimeUpdate}
                onPlaybackFinished={this.playbackFinished}
              />
            </div>
            <div className="Main-Player">
              <ErrorBoundary>
                <AbcPlayer
                  playing={playing}
                  duration={duration}
                  currentTime={currentTime}
                  bpm={bpm}
                  bpmPlusEnabled={bpm + 10 <= this.originalBpm}
                  bpmMinusEnabled={bpm - 10 >= 40}
                  showTutorResultButton={false}
                  showTutorConfigurationButton={false}
                  showOptionPopup={false}
                  showBpmButton={false}
                  drum={false}
                  onCurrentTimeChanged={this.changeCurrentTime}
                  onPlayingChanged={this.changePlayState}
                  onShowTutorResultsButton={null}
                  onShowTutorConfigurationButton={null}
                  onBpmChanged={this.changeBpm}
                  onToggleOptions={null}
                  onDrumChanged={value => {
                    this.setState({ drum: value });
                  }}
                />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    ];
  }

  componentDidMount() {
    this.asynComponentDidMount().finally();
  }

  async asynComponentDidMount() {
    const { match } = this.props;
    const { score_id } = match.params;
    let score;
    try {
      score = await BookProvider.getScore(score_id);
    } catch (e) {
      this.setState({ error: 'Impossibile caricare lo spartito!' });
      return;
    }

    if (!score) {
      this.setState({ error: 'Spartito non trovato!' });
      return;
    }
    this.setState({ score });
  }

  // Subtitle callbacks:
  audioTimeUpdate = currentTime => {
    if (currentTime >= this.state.duration) this.playbackFinished();
    this.setState({ currentTime });
  };

  playbackFinished = () => {};

  tuneLoaded = duration => {
    this.setState({ duration });
  };

  // Player callbacks:
  changeCurrentTime = currentTime => {
    this.setState({ currentTime });
  };

  changePlayState = playing => {
    if (playing === this.state.playing) return;
    this.setState({ playing });
  };

  changeBpm = () => {};
}

export default Karaoke;
